import { ITIN, SSN } from 'apps/auth/constants/fieldsName';
import { PROFILE_USA_OCCUPATION } from 'apps/auth/constants/formName';
import { AUTH_PROFILE_ACCOUNT_ACH_ADD_ACCOUNT, AUTH_PROFILE_SSN, AUTH_SEND_ACH_ADD_ACCOUNT, AUTH_SEND_ACH_ANSWERS } from 'apps/auth/constants/UrlConstants';
import { apiFetchData } from 'apps/auth/helpers/api';
import { logWarn } from 'apps/auth/helpers/clientLogger';

const CAN_SHOW_UPGRADE = 'canShowAmlLevelUpgrade';
const SUCCESS = 'success';
const FAILED = 'failed';
const ERROR = 'error';
const INFO = 'info';
const OCCUPATION = 'occupation';
const SSN_CONFIRM = 'confirm';
const OOW = 'oow';
const PLAID = 'plaid';
const PROOF_ID = 'proof_id';

const updateRedux = (reduxData, serverData, updateFunction) => {
    const newState = {
        ...reduxData,
        ...serverData,
    };
    updateFunction(newState);
};

const requestSsnOrItin = (setScreen, props) => {
    return (fields) => {
        const isError = fields[ITIN].isError || fields[SSN].isError;
        if (!isError) {
            props.toggleSpinner(true);
            apiFetchData(AUTH_PROFILE_SSN, fields)
                .then((json) => {
                    if (json?.messages) {
                        updateRedux(props.pageMessages, json.messages, props.updatePageMessages);
                    }
                    const form = json?.forms[PROFILE_USA_OCCUPATION];
                    if (form) {
                        props.setNewForm(PROFILE_USA_OCCUPATION, form.fields, form.action);
                    }
                    if (json?.extra) {
                        props.updateExtraByName(CAN_SHOW_UPGRADE, json.extra?.[CAN_SHOW_UPGRADE]);
                        if (json.extra?.showOccupationScreen) {
                            setScreen(OCCUPATION);
                        } else if (json.extra?.showAmlLevelUpScreen) {
                            setScreen(INFO);
                        } else if (json.extra?.[CAN_SHOW_UPGRADE]) {
                            setScreen(FAILED);
                        } else {
                            setScreen(SUCCESS);
                        }
                    }
                })
                .finally(() => props.toggleSpinner(false))
                .catch((error) => {
                    logWarn(error);
                });
        }
    };
};

const requestOow = (setScreen, setErrorText, props) => {
    return (toValues) => {
        let ach_answers = {};
        ach_answers['toValues'] = toValues;
        props.toggleSpinner(true);
        apiFetchData(`${AUTH_SEND_ACH_ANSWERS}?fromPrvId=${props.fields?.fromPrvId?.value}`, toValues)
            .then((json) => {
                if (json?.messages) {
                    updateRedux(props.pageMessages, json.messages, props.updatePageMessages);
                }
                if (json?.extra) {
                    updateRedux(props.extra, json.extra, props.setExtra);
                    const {
                        extra: { answers = {}, plaidAccountAction = false },
                    } = json;
                    if (answers && answers.errorMessage) {
                        if (answers.errorMessage) {
                            setErrorText(answers.errorMessage);
                            setScreen(ERROR);
                        }
                    } else if (plaidAccountAction) {
                        setScreen(SUCCESS);
                    }
                }
            })
            .finally(() => props.toggleSpinner(false))
            .catch((error) => {
                logWarn(error);
            });
    };
};
const requestPlaid = (setScreen, setErrorText, props, flowType = 'send') => {
    return (_metadata, public_token) => {
        props.toggleSpinner(true);
        const params = new URLSearchParams({ public_token });
        apiFetchData(`${flowType === 'send' ? AUTH_SEND_ACH_ADD_ACCOUNT : AUTH_PROFILE_ACCOUNT_ACH_ADD_ACCOUNT}?${params.toString()}`, props.fields)
            .then((json) => {
                if (json?.messages) {
                    props.updatePageMessages(json.messages);
                }
                if (json.messageBodyMessages) {
                    props.updateMessages(json.messageBodyMessages);
                }
                if (json.cards) {
                    props.updateCardsList(json.cards);
                }
                if (json?.extra) {
                    requestPlaidProcessExtra(setScreen, setErrorText, props, json);
                }
            })
            .finally(() => props.toggleSpinner(false))
            .catch((error) => {
                logWarn(error);
            });
    };
};

const requestPlaidProcessExtra = (setScreen, setErrorText, props, json) => {
    props.addExtras(json.extra);
    // checks successfully
    if (json.extra.checksSuccess) {
        setScreen(SUCCESS);
    } else if (json.errors && Object.keys(json.errors).length > 0) {
        // further review, need return in extra flags canShowAmlLevelUpgrade = true and proof_id = true
        if (json.errors.errorMessage) {
            setErrorText(json.errors.errorMessage?.body);
            setScreen(ERROR);
        }
        // checks failed
    } else if (json.extra.checksFailed) {
        setScreen(FAILED);
    } else {
        props.toggleModal(false);
    }
};

const isAccountExpired = (account) => {
    return !!(account && account.relinkRequired);
};
export { requestSsnOrItin, requestOow, requestPlaid, isAccountExpired, SUCCESS, FAILED, INFO, SSN_CONFIRM, OOW, ERROR, PLAID, PROOF_ID, OCCUPATION };
